<template>
  <div id="herramientas-proveedor">
    <div class="container-fluid" id="proveedor">
      
      <vx-card class="mb-6" >
        <div class="vx-row">
          <div class="vx-col w-full">
            <h1 class="rg-big-title extrabold rg-title">Mis <span class="orange">herramientas</span>.</h1>
          </div>
        </div>
      </vx-card>

      <vx-card class="mb-base">
        <div class="vx-row">

          <div class="vx-col lg:w-1/2 md:w-3/4 w-full">
            <h3 class="title-primary mt-3 mb-5">Información</h3>

            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- Requisitos del Crédito Solar -->
                <action-button
                  id="reqs-cliente"
                  title="Requisitos del Crédito Solar"
                  actionLink="/informativos/REDGIRASOL_Requisitos_del_solicitantes_Crédito_Solar.pdf"
                  fileName="REDGIRASOL_Requisitos_del_solicitantes_Crédito_Solar.pdf"
                  :download="true"
                  :remoteFile="true"
                  icon="DownloadIcon"
                  color="primary"
                />
              </div>

               <div class="vx-col w-full">
                <!-- Presentación del Crédito Solar -->
                <action-button
                  id="caracteristicas-solar"
                  title="Presentación del Crédito Solar"
                  actionLink="/informativos/Presentación_Crédito_Solar_RedGirasol_2025.pdf"
                  fileName="Presentación_Crédito_Solar_RedGirasol_2025.pdf"
                  :download="true"
                  :remoteFile="true"
                  icon="DownloadIcon"
                  color="primary"
                />
               </div>
            </div>
            <h3 class="title-primary mt-3 mb-5">Tutoriales</h3>
            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- VIDEOS PROMOCIONALES -->
                <action-button
                  id="verificacion-integrador"
                  title="¿Cómo solicitar la verificación como integrador de RedGirasol?"
                  actionLink="https://www.youtube.com/watch?v=FQ2udh0dwxA&feature=youtu.be"
                  fileName=""
                  :download="false"
                  :remoteFile="true"
                  :isVideo="true"
                  icon="PlayIcon"
                  color="primary" />
              </div>
              <div class="vx-col w-full">
                <!-- VIDEOS PROMOCIONALES -->
                <action-button
                  id="solicitud-integrador"
                  title="¿Cómo crear solicitud de crédito persona física?"
                  actionLink="https://www.youtube.com/watch?v=FoZdss4tQMY&feature=youtu.be"
                  fileName=""
                  :download="false"
                  :remoteFile="true"
                  :isVideo="true"
                  icon="PlayIcon"
                  color="primary" />
              </div>
              <div class="vx-col w-full">
                <!-- VIDEOS PROMOCIONALES -->
                <action-button
                  id="verificacion-os"
                  title="¿Cómo verificar la identidad del Obligado Solidario?"
                  actionLink="https://www.youtube.com/watch?v=JjUbVJPVQFs&feature=youtu.be"
                  fileName=""
                  :download="false"
                  :remoteFile="true"
                  :isVideo="true"
                  icon="PlayIcon"
                  color="primary" />
              </div>
              <div class="vx-col w-full">
                <!-- VIDEOS PROMOCIONALES -->
                <action-button
                  id="contratos-integrador"
                  title="¿Cómo firmar contratos?"
                  actionLink="https://www.youtube.com/watch?v=vMpgMRFT94A&feature=youtu.be"
                  fileName=""
                  :download="false"
                  :remoteFile="true"
                  :isVideo="true"
                  icon="PlayIcon"
                  color="primary" />
              </div>
            </div>
          </div>

          <!-- SOLARES -->
          <div class="vx-col lg:w-1/2 md:w-3/4 w-full">
            <h3 class="title-primary mt-3 mb-5">Para tus clientes</h3>

            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- PYMES -->
                <action-button
                  id="reqs-cliente"
                  title="Folleto Crédito Solar PYMES"
                  actionLink="/informativos/REDGIRASOL®-Credito-Solar-PYMES.pdf"
                  fileName="REDGIRASOL®-Credito-Solar-PYMES.pdf"
                  :download="true"
                  :remoteFile="true"
                  icon="DownloadIcon"
                  color="primary"
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- RedGirasol_NegociosSolares -->
                <action-button
                  id="reqs-cliente"
                  title="Folleto Crédito Solar Negocios"
                  actionLink="/informativos/REDGIRASOL®-Credito-Solar-Negocios.pdf"
                  fileName="REDGIRASOL®-Credito-Solar-Negocios.pdf"
                  :download="true"
                  :remoteFile="true"
                  icon="DownloadIcon"
                  color="primary"
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- Folleto para Crédito de Hogares -->
                <action-button
                  id="reqs-cliente"
                  title="Folleto Crédito Solar Hogares"
                  actionLink="/informativos/REDGIRASOL®-Credito-Solar-Hogares.pdf"
                  fileName="REDGIRASOL®-Credito-Solar-Hogares.pdf"
                  :download="true"
                  :remoteFile="true"
                  icon="DownloadIcon"
                  color="primary"
                />
              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <div v-if="isProgramSupplier">
        <program-tools :isSupplier="true"></program-tools>
      </div>

    </div>
  </div>
</template>

<script>
import ActionButton from '@components/supplier/ActionButton.vue'
import ProgramTools from '@views/programs/kof/Tools.vue'
export default {
  components: {
    ActionButton,
    ProgramTools
  },
  computed: {
    isProgramSupplier(){
      return this.SupplierOrAgentProgramAccess;
    },
  }
}
</script>
<style scoped>
  .rg-title {
      font-size: 3rem !important;
  }
</style>